import { Injectable } from '@angular/core';
import { StaffLoginResponse } from 'projects/shared/models/interfaces/staff';
import { BehaviorSubject, Observable } from 'rxjs';
import { IChangePasswordPayload } from '../change-password/interface/change-password.interface';
import { HttpClient } from '@angular/common/http';
import { environment } from 'projects/shared/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  userData = new BehaviorSubject<StaffLoginResponse>({} as StaffLoginResponse)
  avatarLoader = new BehaviorSubject<boolean>(false)

  constructor(private _http: HttpClient) { }

  changePassword(payload: IChangePasswordPayload): Observable<IChangePasswordPayload> {
    return this._http.patch<IChangePasswordPayload>(`${environment.apiUrl}staff/change-password`,payload )
  }
}
